export const newsletterData = [
  {
    id: 1,
    newsletterId: 'sub_today',
    title: 'This is TODAY',
    description: 'Your day starts here. The latest in news, pop culture, wellness and more from TODAY.',
    image: 'https://media-cldnry.s-nbcnews.com/image/upload/newscms/2022_19/3551940/this-is-today-front-7faee3.png',
  },
  {
    id: 2,
    newsletterId: 'sub_food',
    title: 'TODAY Food',
    description: 'From celebrity chef recipes and easy meal tips to viral food trends and restaurant industry news, let\'s make every day more delicious – starting TODAY!',
    image: 'https://media-cldnry.s-nbcnews.com/image/upload/newscms/2021_16/1705477/today-newsletter-food1.jpg',
  },
  {
    id: 3,
    newsletterId: 'sub_starttodaywellness',
    title: 'Start TODAY',
    description: 'Start TODAY is the destination to help you become a healthier, happier and better you. It’s all about overcoming the biggest hurdle — getting started.',
    image: 'https://media-cldnry.s-nbcnews.com/image/upload/newscms/2023_22/3609171/starttoday_square-v3.png',
  },
  {
    id: 4,
    newsletterId: 'sub_ontheshow',
    title: 'TODAY On the Show',
    description: 'Missed the show? Catch up on our favorite and most talked about TODAY moments.',
    image: 'https://media-cldnry.s-nbcnews.com/image/upload/rockcms/2025-01/TODAY-savannah-craig-zz-250109-03-c570aa.jpg',
  },
  {
    id: 5,
    newsletterId: 'sub_parenting',
    title: 'TODAY Parents',
    description: 'We\'re in it together! Get trending parents stories, inspiration and news you can use sent to your inbox each week.',
    image: 'https://media-cldnry.s-nbcnews.com/image/upload/newscms/2021_15/1702359/today-newsletter-parents-square-02.jpg',
  },
  {
    id: 6,
    newsletterId: 'sub_stuffwelove',
    title: 'Stuff We Love',
    description: 'A daily roundup of items that will make your life easier, healthier and more stylish.',
    image: 'https://media-cldnry.s-nbcnews.com/image/upload/newscms/2023_15/1984544/230412-stl-vl-1x1.jpg',
  },
  {
    id: 7,
    newsletterId: 'sub_bookclub',
    title: 'Read with Jenna',
    description: 'Each month, Jenna Bush Hager and TODAY will pick a new book to read together and discuss.',
    image: 'https://media-cldnry.s-nbcnews.com/image/upload/newscms/2021_11/1688037/read-with-jenna-callout-mc-square-210316.jpg',
  },
  {
    id: 8,
    newsletterId: 'sub_todayupdates',
    title: 'Today updates',
    description: 'Be notified when TODAY is in your area and receive latest updates and special offers from the show.',
    image: 'https://media-cldnry.s-nbcnews.com/image/upload/rockcms/2025-01/TODAY-savannah-craig-zz-250109-01-01b7e5.jpg',
  },
];

